<template>
  <section ref="productCtaContainer" class="product-images-cta-container">
    <button
      v-if="outfittingItem?.label"
      class="cta-item"
      :aria-label="outfittingItem.label?.split('<br>')[0]?.toLowerCase()"
      @click="handleCtaClick"
      @mouseenter="outfittingItem?.onMouseEnterHandler"
      @mouseleave="outfittingItem?.onMouseLeaveHandler"
      @focus="outfittingItem?.onMouseEnterHandler"
      @blur="outfittingItem?.onMouseLeaveHandler"
    >
      <span :class="[outfittingItem.customCssClass || '']">{{ desktopLabel }}</span>
      <span class="stylitics-icon margin-left-xxs"></span>
    </button>
  </section>
</template>

<script setup lang="ts">
import useOutfittingCta from '~/composables/useProductImagesCta/useOutfittingCta';

const { init, outfittingItem } = useOutfittingCta();

const desktopLabel = computed(() => outfittingItem.value?.label?.replace(/<br\s*\/?>/gi, ' ') ?? 'Try it with');

onMounted(async () => {
  await init();
});

const handleCtaClick = () => {
  if (outfittingItem.value?.onClickHandler) {
    outfittingItem.value.onClickHandler();
  }

  // move focus to outfitting section for accessibility
  if (outfittingItem.value?.id === 'outfitting') {
    const outfittingSection = document.querySelector('#stylitics-container');
    if (outfittingSection) {
      const firstInteractive: HTMLElement | null = outfittingSection.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );
      if (firstInteractive) {
        firstInteractive.focus();
      }
    }
  }
};
</script>




<style lang="scss" scoped>
@import '~settingSCSS';
@keyframes product-images-cta-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.product-images-cta-container {
  position: absolute;
  bottom: rem-calc(16);
  right: rem-calc(16);
  opacity: 0;
  z-index: 10;

  animation-name: product-images-cta-fade;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  animation-duration: 0.5s;

  .cta-item {
    display: flex;
    align-items: center;
    padding: rem-calc(8);
    border-radius: rem-calc(20);
    background-position: center;
    background-color: $white-overlay-color-2;
    cursor: pointer;

    &:hover {
      background-color: $hover-color;
    }
  }
  .stylitics-icon {
    width: rem-calc(24);
    height: rem-calc(24);
    display: block;
    background-repeat: no-repeat;
  }
}


.cta-item {
  box-shadow: 0px 0px 4px 0px #00000040;
}
</style>